export type ParentColorScheme = 'light' | 'dark';

function asParentColorScheme(value: string | null | undefined): ParentColorScheme | undefined {
  return value === 'dark' || value === 'light' ? value : undefined;
}

export function getParentColorScheme(doc: Document = window.document): ParentColorScheme | undefined {
  const html = doc.documentElement;

  const inline = asParentColorScheme(html.style.colorScheme);
  if (inline) return inline;

  const dataTheme = asParentColorScheme(html.getAttribute('data-theme'));
  if (dataTheme) return dataTheme;

  if (html.classList.contains('dark')) return 'dark';
  if (html.classList.contains('light')) return 'light';

  try {
    const view = doc.defaultView || window;
    return asParentColorScheme(view.getComputedStyle(html).colorScheme);
  } catch {
    return undefined;
  }
}
